import type { JSX } from "react";
import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "primary" | "secondary" | "quiet" | "danger" | "warning";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: "default" | "compact";
  busy?: boolean;
  outlined?: boolean;
  children: ReactNode;
};

export function Button({
  variant = "primary",
  size = "default",
  busy = false,
  outlined = false,
  disabled,
  className = "",
  children,
  type = "button",
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      className={`vui-button vui-button--${variant} ${outlined ? "vui-button--outlined" : ""} ${size === "compact" ? "vui-button--compact" : ""} ${className}`.trim()}
    >
      {busy ? (
        <span className="vui-button__spinner" aria-hidden="true" />
      ) : null}
      <span>{children}</span>
    </button>
  );
}
